import { ErrorCodes } from '@aline/common';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import * as Sentry from '@sentry/react';

export function getExternalToolkitMutationErrorMessage(error: unknown, fallback: string): string {
  if (CombinedGraphQLErrors.is(error)) {
    const userInputError = error.errors.find(
      graphQLError => graphQLError.extensions?.code === ErrorCodes.BAD_USER_INPUT
    );
    if (userInputError) return userInputError.message;
  }
  Sentry.captureException(error);
  return fallback;
}
